export const cols_3 = [{
        title: "排名",
        key: "ranking",
        width: '10vw',
        align: "center",
        slot: "ranking"
    },
    {
        title: "图片",
        key: "pics",
        align: "center",
        slot: "img"
    },
    {
        title: "款号",
        key: "goodsNo",
        align: "center"
    },
    {
        title: "累计入库",
        key: "number",
        align: "center"
    },
    {
        title: "销量",
        key: "quantity",
        align: "center"
    },
    {
        title: "大仓库存",
        key: "warehouseQty",
        align: "center"
    }
]

export const cols_4 = [{
        title: "排名",
        width: '10vw',
        key: "ranking",
        align: "center",
        slot: "ranking"
    },
    {
        title: "图片",
        key: "pics",
        align: "center",
        slot: "img"
    },
    {
        title: "款号",
        key: "goodsNo",
        align: "center"
    },
    {
        title: "累计出库",
        key: "number",
        align: "center"
    },
    {
        title: "销量",
        key: "quantity",
        align: "center"
    },
    {
        title: "大仓库存",
        key: "storeQty",
        align: "center"
    }

]